var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countdownComponent"},_vm._l((_vm.pastNumbersArray),function(n){return _c('div',{key:n,staticClass:"number d-flex align-items-center justify-content-center",class:{last: n === 0}},[_vm._v(" "+_vm._s(n)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }